<div class="panel panel-info">
    <div class="panel-heading">
        <h3 class="panel-title">{{header}}</h3>
    </div>
    <div class="panel-body">
        <ng-content></ng-content>
    </div>
</div>